/**
 * Eventbrite sign-in URL with referrer and stld=1 (product convention).
 */
export function buildEventbriteSignInUrl(eventbriteBaseUrl: string, referrer: string): string {
  const base = eventbriteBaseUrl.replace(/\/$/, '');
  const params = new URLSearchParams({ referrer, stld: '1' });
  return `${base}/signin/?${params.toString()}`;
}
